import { Grid, Paper, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { IRootReducer } from "../../../reducers";

import { useTranslation } from "react-i18next";
import { isDeviceLocationAvailable } from "../../../helpers/deviceHelpers";
import DeviceMap from "../DeviceMap/DeviceMap.component";
import ShowDeviceAddress from "./ShowDeviceAddress.component";
import ShowDeviceBasics from "./ShowDeviceBasics.component";
import ShowDeviceDetails from "./ShowDeviceDetails.component";

const ShowDevice = () => {
  const device = useSelector((state: IRootReducer) => state.devices.show);
  const { t } = useTranslation();

  if (!device) return null;

  let locationAvailable = isDeviceLocationAvailable(device);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <h1>{device.name}</h1>
        <h5>{device.address}</h5>
        <p>{device.description}</p>
      </Grid>
      <Grid item md={12} lg={6}>
        <Grid item sx={{ mb: 3 }}>
          <Paper sx={{ p: 1 }}>
            <ShowDeviceBasics device={device} />
          </Paper>
        </Grid>
        <Grid item>
          <Paper sx={{ p: 1 }}>
            <ShowDeviceDetails details={device.details} />
          </Paper>
        </Grid>
      </Grid>
      <Grid item md={12} lg={6}>
        <Grid item sx={{ mb: 3 }}>
          <Paper sx={{ p: 1 }}>
            {device.details?.physicalAddress ? (
              <ShowDeviceAddress
                physicalAddress={device.details?.physicalAddress}
              />
            ) : (
              <Typography color="gray">
                {t("device.messages.noPhysicalAddress")}
              </Typography>
            )}
          </Paper>
        </Grid>

        <Grid item>
          <Paper sx={{ p: 1 }}>
            {locationAvailable ? (
              <DeviceMap device={device} />
            ) : (
              <Typography color="gray">
                {t("device.messages.NoLocation")}
              </Typography>
            )}
          </Paper>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ShowDevice;
